import { cn } from '@rouvydev/web-components/utils'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { Icon } from '~/components/icon'
import { Socials, type SocialTypes } from '~/components/socials'

type Props = {
  name: string
  jobTitle: string | null | undefined
  socials:
    | ({
        type: SocialTypes
        link: string
      } | null)[]
    | null
    | undefined
  avatar: string | undefined
  perex: string | null | undefined
  authorSlug?: string
  className?: string
}
export function Author({
  name,
  jobTitle,
  socials,
  avatar,
  perex,
  authorSlug,
  className,
}: Props) {
  const { t } = useTranslation(['blog'])
  return (
    <div className={cn('flex flex-col gap-6 md:flex-row', className)}>
      {avatar && (
        <div className="flex justify-center">
          <div
            className={`h-[160px] w-[160px] rounded-full bg-cover bg-center md:h-[80px] md:w-[80px]`}
            style={{ backgroundImage: `url(${avatar})` }}
          ></div>
        </div>
      )}
      <div>
        <div></div>
        <div className="flex flex-col gap-4">
          <div className="text-body-18 leading-7 font-semibold text-global-white">
            {name}
          </div>
          <div className="text-body-12 font-medium text-text-muted">
            {jobTitle}
          </div>
        </div>

        <div>{socials && <Socials socials={socials} />}</div>
        <div className="py-4 text-body-12 text-global-white">{perex}</div>
        {authorSlug && (
          <Link
            to={`/blog/author/${authorSlug}`}
            className="flex flex-row gap-2 text-body-12 text-text-informative"
          >
            {t('read_more_from_author')} {name}
            <Icon
              name="chevron-right"
              className="h-5 w-5 fill-icon-informative"
            />
          </Link>
        )}
      </div>
    </div>
  )
}
